import {
  SET_FEEDBACK_OBJECT,
  SET_BULKUPDATE_SUMMARY,
  SET_RECORD_ACCESS_ERROR,
  SET_FIELD_ACCESS_ERROR,
  SET_VALIDATION_ERROR,
  SET_SAVE_ERROR,
} from '@/store/mutation-types'

export default {
  state: {
    feedbackObject: Object,
    isFeedbackServerException: false,
    numberOfRecordsUpdated: String,
    numberOfRecordsSelected: String,
    isRecordAccessErrors: false,
    isFieldAccessErrors: false,
    isValidationErrors: false,
    isSaveErrors: false,
    recordAccessErrors: [],
    fieldAccessErrors: [],
    validationErrors: [],
    saveErrors: [],
  },
  mutations: {
    [SET_FEEDBACK_OBJECT](state, feedbackObject) {
      state.feedbackObject = feedbackObject
      if (feedbackObject.error) {
        state.isFeedbackServerException = true
      }
    },
    [SET_BULKUPDATE_SUMMARY](state, bulkUpdateResponse) {
      state.numberOfRecordsUpdated = bulkUpdateResponse.numberOfRecordsUpdated
      state.numberOfRecordsSelected = bulkUpdateResponse.totalNumberOfRecords
    },
    [SET_RECORD_ACCESS_ERROR](state, record) {
      state.isRecordAccessErrors = true
      const recordAccessErrorObject = {}
      recordAccessErrorObject.recordId = record.recordId
      recordAccessErrorObject.link = record.link
      state.recordAccessErrors.push(recordAccessErrorObject)
    },
    [SET_FIELD_ACCESS_ERROR](state, { record, errorField }) {
      state.isFieldAccessErrors = true
      const fieldAccessErrorObject = {}
      fieldAccessErrorObject.recordId = record.recordId
      fieldAccessErrorObject.fieldId = errorField
      fieldAccessErrorObject.link = record.link
      state.fieldAccessErrors.push(fieldAccessErrorObject)
    },
    [SET_VALIDATION_ERROR](state, { record, key, validationMessage }) {
      state.isValidationErrors = true
      const validationErrorObject = {}
      validationErrorObject.recordId = record.recordId
      validationErrorObject.fieldId = key
      validationErrorObject.validationMessage = validationMessage
      validationErrorObject.link = record.link
      state.validationErrors.push(validationErrorObject)
    },
    [SET_SAVE_ERROR](state, { record, error }) {
      state.isSaveErrors = true
      const saveErrorObject = {}
      saveErrorObject.recordId = record.recordId
      saveErrorObject.errorMessage = error.saveError
      state.saveErrors.push(saveErrorObject)
    },
  },
  actions: {
    setFeedbackData({ commit }, feedbackObject) {
      // feedback object
      commit(SET_FEEDBACK_OBJECT, feedbackObject)

      if (!feedbackObject.error) {
        // bulk update summary
        const bulkUpdateResponse = feedbackObject.bulkUpdateResponse
        commit(SET_BULKUPDATE_SUMMARY, bulkUpdateResponse)

        // bulk update access errors
        const rootType = feedbackObject.rootType
        if (
          bulkUpdateResponse &&
          Object.prototype.hasOwnProperty.call(bulkUpdateResponse, rootType)
        ) {
          bulkUpdateResponse[rootType].forEach((record) => {
            const error = record.error
            if (error && error.accessError) {
              if (error.accessError.component) {
                commit(SET_RECORD_ACCESS_ERROR, record)
              }
              if (error.accessError.fields) {
                error.accessError.fields.forEach((errorField) => {
                  commit(SET_FIELD_ACCESS_ERROR, { record, errorField })
                })
              }
            }
            // bulk update validation errors
            if (error && error.validationError) {
              Object.keys(error.validationError).forEach((key) => {
                error.validationError[key].forEach((validationMessage) => {
                  commit(SET_VALIDATION_ERROR, { record, key, validationMessage })
                })
              })
            }
            // bulk update unexpected save errors
            if (error && error.saveError) {
              commit(SET_SAVE_ERROR, { record, error })
            }
          })
        }
      }
    },
  },
}
